import { Border } from 'themes/interfaces';

export default {
  factor: 4,
  radius: 1, // 4px (factor * radius = 4px)
  square: 0,
  circle: 30
} as Border;
